'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('@chakra-ui/react');

const RepeatClockIcon = react.createIcon({
  displayName: "RepeatClockIcon",
  path: /* @__PURE__ */ jsxRuntime.jsxs("g", { fill: "currentColor", children: [
    /* @__PURE__ */ jsxRuntime.jsx("path", { d: "M12.965,6a1,1,0,0,0-1,1v5.5a1,1,0,0,0,1,1h5a1,1,0,0,0,0-2h-3.75a.25.25,0,0,1-.25-.25V7A1,1,0,0,0,12.965,6Z" }),
    /* @__PURE__ */ jsxRuntime.jsx("path", { d: "M12.567,1.258A10.822,10.822,0,0,0,2.818,8.4a.25.25,0,0,1-.271.163L.858,8.309a.514.514,0,0,0-.485.213.5.5,0,0,0-.021.53l2.679,4.7a.5.5,0,0,0,.786.107l3.77-3.746a.5.5,0,0,0-.279-.85L5.593,9.007a.25.25,0,0,1-.192-.35,8.259,8.259,0,1,1,7.866,11.59,1.25,1.25,0,0,0,.045,2.5h.047a10.751,10.751,0,1,0-.792-21.487Z" })
  ] })
});

exports.RepeatClockIcon = RepeatClockIcon;
